import { useMutation, useQueryClient, UseMutationResult } from '@tanstack/react-query';
import { updateUserAgents as updateUserAgentsAPI } from 'src/common/Scraper';
import { UpdateUserAgentsPayload, UpdateUserAgentsResponse } from '../types/user-agents.type';
import { OrbitAIAgents } from '../types/types';
import { useDispatch } from 'react-redux';
import { setOrbitAISnackBar } from 'src/redux/siteAuditReducer';

type UseUpdateUserAgentsProps = OrbitAIAgents

/**
 * React Query mutation hook to update Orbit AI agent settings.
 * Automatically invalidates 'getUserAgentDetails' query cache on success.
 */
export const useUpdateUserAgents = (agent?: UseUpdateUserAgentsProps): UseMutationResult<
  UpdateUserAgentsResponse,
  Error,
  UpdateUserAgentsPayload
> => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient();

  return useMutation<UpdateUserAgentsResponse, Error, UpdateUserAgentsPayload>({
    mutationKey: ['updateUserAgents', agent],
    mutationFn: (payload: UpdateUserAgentsPayload) => updateUserAgentsAPI(payload),
    onSuccess: (_, variables) => {
      if (variables?.site_id) {
        queryClient.invalidateQueries({
          queryKey: ['getUserAgentDetails', variables.site_id],
        });
      }
    },
    onError: (error) => {
      console.error('Error updating user agents:', error);
      // dispatch error for orbit AI
      dispatch(setOrbitAISnackBar({
        open: true,
        message: error?.message || 'Failed to update agents',
        type: 'error',
      }));
    },
  });
};

export default useUpdateUserAgents;
